import { Environment } from '../types';
export const getObsEnvironment = () => {
    var _a, _b, _c, _d;
    if (typeof window !== 'undefined' && window.location.href.includes('savingglobal')) {
        if ((_a = window.location.host) === null || _a === void 0 ? void 0 : _a.includes(Environment.STAGING)) {
            return Environment.STAGING;
        }
        if ((_b = window.location.host) === null || _b === void 0 ? void 0 : _b.includes(Environment.ONBOARDING)) {
            return Environment.ONBOARDING;
        }
        if (((_c = window.location.host) === null || _c === void 0 ? void 0 : _c.includes('localhost')) ||
            ((_d = window.location.host) === null || _d === void 0 ? void 0 : _d.includes('raisin-dev.network'))) {
            return Environment.DEVELOPMENT;
        }
        return Environment.PRODUCTION;
    }
    return null;
};
//# sourceMappingURL=env.js.map